export default class SavePiskel {
    constructor(state) {
        this.state = state;
    }

    save() {
        const savePiskel = document.querySelector('.save-piskel');

        savePiskel.addEventListener('click', e => {
            if (e.target.matches('.save-piskel-clone')) {
                const piskelClone = {};
                piskelClone.piskelClone = {
                    name: 'my-piskel-clone',
                    description: 'created with app piskel-clone'
                };
                piskelClone.version = '1.0';
                piskelClone.settings = {
                    canvas: {
                        height: '32',
                        width: '32'
                    },
                    fps: `${this.state.fps}`
                };
                piskelClone.Frames = this.state.frames;

                SavePiskel.download(e.target, piskelClone, 'my-piskel-clone.clpiskel');
            }

            if (e.target.matches('.save-piskel')) {
                const layout = this.state.frames
                    .map((item, index) => {
                        return `[${index}]`;
                    })
                    .join(',');

                const canvas = document.createElement(`canvas`);
                canvas.height = 32;
                canvas.width = this.state.frames.length * 32;
                const context = canvas.getContext('2d');
                const img = new Image();

                let imageBase64 = this.state.frames.map((item, index) => {
                    img.src = this.state.frames[index].slice(5, -2);
                    context.drawImage(img, index * 32, 0);
                    return `${canvas.toDataURL()}`;
                });

                imageBase64 = imageBase64[imageBase64.length - 1];

                // eslint-disable-next-line prettier/prettier
                const piskelStr = `{"name":"Layer 2","opacity":1,"frameCount":${this.state.frames.length},"chunks":[{"layout":[${layout}],"base64PNG":"${imageBase64}"}]}`;

                const piskelClone = {};
                piskelClone.modelVersion = 2;
                piskelClone.piskel = {
                    name: 'my-piskel',
                    description: 'created with app piskel-clone',
                    fps: this.state.fps,
                    height: 32,
                    width: 32,
                    layers: [piskelStr],
                    hiddenFrames: []
                };

                SavePiskel.download(e.target, piskelClone, 'my-piskel.piskel');
            }
        });
    }

    static download(target, object, fileName) {
        const link = target;
        const json = JSON.stringify(object);
        const blob = new Blob([json], { type: 'octet/stream' });
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.target = '_blank';
        link.download = fileName;
    }
}
